var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(true),expression:"true"}],attrs:{"element-loading-background":"#fafafa"}})}
var staticRenderFns = []

export { render, staticRenderFns }